(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  // Contact form: fill the Subject and the message from the link's ?topic=, record the page the visitor came from,
  // scroll to the form when a call to action sent them, and forward a posted form to the success page if Shopify
  // brought the visitor back here instead. Runs once the document is ready (the compiled scripts can load early).
  (() => {
    const humanise = (slug) => slug.replace(/[-_]+/g, ' ').replace(/^./, (c) => c.toUpperCase());
    const init = (root) => {
      root.querySelectorAll('[data-contact-form]').forEach((section) => {
        if (section.dataset.contactReady) return;
        section.dataset.contactReady = 'true';
        if (section.dataset.purpose !== 'download' && section.querySelector('[data-contact-posted]') && section.dataset.successUrl) {
          window.location.replace(section.dataset.successUrl);
          return;
        }
        let prefills = {};
        try { prefills = JSON.parse(section.querySelector('[data-contact-prefills]').textContent || '{}'); } catch (e) { prefills = {}; }
        const params = new URLSearchParams(window.location.search);
        const topic = (params.get('topic') || section.dataset.defaultTopic || '').trim();
        const subject = section.querySelector('[data-contact-subject]');
        const source = section.querySelector('[data-contact-source]');
        const message = section.querySelector('[data-contact-message]');
        // The page the visitor came from. Shopify's spam check can send the visitor to its /challenge page and back,
        // so that page is never taken as the source: the value found on the first visit is kept for the tab instead.
        let from = params.get('from') || '';
        let viaChallenge = false;
        if (!from && document.referrer) {
          try {
            const r = new URL(document.referrer);
            if (r.host === window.location.host) {
              if (r.pathname.indexOf('/challenge') === 0) viaChallenge = true;
              else from = r.pathname + r.search;
            }
          } catch (e) { from = ''; }
        }
        const fromKey = 'contact_came_from:' + window.location.pathname;
        try {
          if (viaChallenge) from = sessionStorage.getItem(fromKey) || '';
          else sessionStorage.setItem(fromKey, from || window.location.pathname);
        } catch (e) {}
        if (source) source.value = from || window.location.pathname;
        let filled = '';
        const apply = (name) => {
          const p = prefills[name] || {};
          if (subject) subject.value = p.subject || humanise(name);
          if (message && (!message.value || message.value === filled)) {
            message.value = p.message || '';
            filled = message.value;
          }
        };
        if (topic) {
          apply(topic);
          if (params.get('topic')) section.scrollIntoView({ block: 'start' });
        }
        // Leads to Zapier: post the submission first (three seconds at most), then submit Shopify's form as usual
        const form = section.querySelector('form.contact-form__form');
        if (form && !form.dataset.zapierReady) {
          form.dataset.zapierReady = 'true';
          // Campaign attribution saved by snippets/attribution.liquid (the five UTMs, five click IDs, landing_page and
          // referrer, kept 30 days); every key is sent, empty when there is nothing saved
          const ATTRIBUTION_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'li_fat_id', 'landing_page', 'referrer'];
          const attribution = () => {
            try {
              return (window.iStoreAttribution && window.iStoreAttribution.get()) || {};
            } catch (e) {
              return {};
            }
          };
          // The lead goes out when the form's data is actually submitted, which is after Shopify's hCaptcha check has
          // passed: hCaptcha holds every submit event (preventDefault), runs its check, and only on a pass submits the
          // form with the browser's native submit(), which fires the standard formdata event but no second submit
          // event. So the post waits for formdata carrying hCaptcha's token, and a submission hCaptcha stops never
          // reaches Zapier. A form without hCaptcha (not bound) posts on its plain submit. Sent once per page, as a
          // standard form post (no preflight) with keepalive, which the browser completes through the navigation.
          form.addEventListener('formdata', (event) => {
            const url = (section.dataset.zapierUrl || '').trim();
            if (!url || form.dataset.zapierSent === 'true') return;
            const data = event.formData;
            const get = (name) => String(data.get(name) || '').trim();
            if (form.hasAttribute('data-hcaptcha-bound') && !get('h-captcha-response')) return;
            form.dataset.zapierSent = 'true';
            const body = new URLSearchParams({
              form: section.dataset.formName || '',
              enquiry: get('contact[Enquiry]'),
              came_from: get('contact[Came from]'),
              page: window.location.pathname + window.location.search,
              first_name: get('contact[First name]'),
              last_name: get('contact[Last name]'),
              email: get('contact[email]'),
              phone: get('contact[Phone]'),
              company: get('contact[Company]'),
              job_title: get('contact[Job title]'),
              fleet_size: get('contact[Fleet size]'),
              industry: get('contact[Industry]'),
              message: get('contact[body]'),
              popia_consent: data.has('contact[POPIA consent]') ? 'true' : 'false',
              submitted_at: new Date().toISOString(),
            });
            // The trap only when something filled it: an always-present empty "trap" fails a Zap filter written as
            // "trap does not exist", which is how the Flow (whitepaper) leads, which carry no trap, were passing
            // while the form leads were not (Marnel, 5 October 2026).
            const trap = get('website_url');
            if (trap) body.set('trap', trap);
            const saved = attribution();
            ATTRIBUTION_KEYS.forEach((key) => body.set(key, String(saved[key] || '')));
            // sendBeacon queues the post for delivery even as the page unloads; fetch with keepalive is the fallback
            // where the beacon is refused (queue full) or missing. Both send a standard form post, no preflight.
            let queued = false;
            try {
              queued = !!(navigator.sendBeacon && navigator.sendBeacon(url, body));
            } catch (error) {
              queued = false;
            }
            if (!queued) {
              try {
                fetch(url, { method: 'POST', mode: 'cors', keepalive: true, body })
                  .catch((error) => { console.warn('Lead post did not complete', error && error.name); });
              } catch (error) {
                console.warn('Lead post did not start', error && error.name);
              }
            }
          });
        }
        // A call to action on this same page: fill the form in place and scroll to it, no reload
        document.addEventListener('click', (event) => {
          const link = event.target.closest && event.target.closest('a[href*="topic="]');
          if (!link) return;
          let url;
          try { url = new URL(link.href, window.location.href); } catch (e) { return; }
          const name = (url.searchParams.get('topic') || '').trim();
          if (!name || url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
          event.preventDefault();
          apply(name);
          section.scrollIntoView({ block: 'start' });
          const first = section.querySelector('input:not([type="hidden"]), select, textarea');
          if (first) first.focus({ preventScroll: true });
        });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edr-tabs"] && !Shopify.designMode) return;
  try {
    
  // EDR tabs: the ARIA tabs pattern with automatic activation. Arrow keys, Home and End move between tabs and select
  // them; one panel shows at a time. Without this script every panel stays visible.
  (() => {
    const init = (root) => {
      root.querySelectorAll('[data-edr-tabs]').forEach((section) => {
        if (section.dataset.edrReady) return;
        const tabs = [...section.querySelectorAll('[data-edr-tab]')];
        const panels = [...section.querySelectorAll('[data-edr-panel]')];
        if (!tabs.length) return;
        section.dataset.edrReady = 'true';
        const select = (index, focus) => {
          tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.tabIndex = on ? 0 : -1;
            if (panels[i]) panels[i].hidden = !on;
          });
          if (focus) tabs[index].focus();
        };
        tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => select(i, false));
          tab.addEventListener('keydown', (event) => {
            let next = null;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % tabs.length;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next === null) return;
            event.preventDefault();
            select(next, true);
          });
        });
        const current = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        select(current < 0 ? 0 : current, false);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const tab = event.target.closest && event.target.closest('[data-edr-tab]');
      if (tab) tab.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-list"] && !Shopify.designMode) return;
  try {
    
  // Events list: the mobile sliders, the desktop filters and the browser-side check of the date.
  (() => {
    // One slider per group: the list scrolls natively; the arrows scroll by one card and are disabled at the ends.
    if (!customElements.get('events-slider')) {
      customElements.define('events-slider', class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-slider-track]');
          this.prev = this.querySelector('[data-slider-prev]');
          this.next = this.querySelector('[data-slider-next]');
          if (!this.track || !this.prev || !this.next) return;
          this.onScroll = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.update());
          };
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.prev.addEventListener('click', () => this.go(-1));
          this.next.addEventListener('click', () => this.go(1));
          this.resize = new ResizeObserver(() => this.update());
          this.resize.observe(this.track);
          this.update();
        }
        disconnectedCallback() {
          if (this.resize) this.resize.disconnect();
          if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        }
        step() {
          const card = this.track.querySelector(':scope > li:not([hidden])');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
        }
        go(direction) {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: direction * this.step(), behavior: reduce ? 'auto' : 'smooth' });
        }
        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const x = this.track.scrollLeft;
          this.toggleAttribute('data-overflowing', max > 1);
          this.prev.disabled = x <= 1;
          this.next.disabled = x >= max - 1;
          const active = document.activeElement;
          if (active === this.next && this.next.disabled) this.prev.focus({ preventScroll: true });
          if (active === this.prev && this.prev.disabled) this.next.focus({ preventScroll: true });
        }
      });
    }

    // Today's date in South African time, as YYYY-MM-DD, the same form the cards carry in data-until
    const todayInSouthAfrica = () => {
      try {
        return new Intl.DateTimeFormat('en-CA', { timeZone: 'Africa/Johannesburg', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      } catch (e) {
        return '';
      }
    };

    const init = (root) => {
      root.querySelectorAll('[data-events-list]').forEach((section) => {
        if (section.dataset.eventsReady) return;
        section.dataset.eventsReady = 'true';
        const cards = [...section.querySelectorAll('[data-event]')];
        const filters = section.querySelector('[data-events-filters]');
        const groups = section.querySelector('[data-events-groups]');
        const noMatch = section.querySelector('[data-events-no-match]');
        const empty = section.querySelector('[data-events-empty]');
        if (!cards.length) return;

        // A cached page can outlive a date: hide any card whose last day has passed, by the browser's clock
        const today = todayInSouthAfrica();
        if (today) {
          cards.forEach((card) => {
            if (card.dataset.until && card.dataset.until < today) card.dataset.past = 'true';
          });
        }

        const state = { category: 'all', city: 'all' };
        const apply = () => {
          let shown = 0;
          cards.forEach((card) => {
            const visible = card.dataset.past !== 'true'
              && (state.category === 'all' || card.dataset.category === state.category)
              && (state.city === 'all' || card.dataset.city === state.city);
            card.hidden = !visible;
            if (visible) shown += 1;
          });
          section.querySelectorAll('[data-events-group]').forEach((group) => {
            const any = group.querySelector('[data-event]:not([hidden])');
            group.hidden = !any;
          });
          const live = cards.filter((card) => card.dataset.past !== 'true').length;
          if (empty) empty.hidden = live > 0;
          if (filters) filters.hidden = live === 0;
          if (groups) groups.hidden = live === 0;
          if (noMatch) noMatch.hidden = !(live > 0 && shown === 0);
        };
        if (filters) {
          filters.addEventListener('click', (event) => {
            const button = event.target.closest('[data-filter-group]');
            if (!button) return;
            const group = button.dataset.filterGroup;
            state[group] = button.dataset.filterValue;
            filters.querySelectorAll(`[data-filter-group="${group}"]`).forEach((b) => {
              b.setAttribute('aria-pressed', b === button ? 'true' : 'false');
            });
            apply();
          });
        }
        apply();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  // FAQs accordion, on the footer's pattern (sections/footer.liquid): a question's button toggles its answer's
  // `hidden` and its own aria-expanded; opening a question closes any other open answer in the same section (one
  // answer open at a time, UAT D52, 3 October 2026); Escape inside an open answer closes it
  // and returns focus to its question. Enter and Space work because the question is a real button. A custom
  // element is not needed: one delegated listener serves every FAQs section, including ones the theme editor adds.
  if (!window.faqsReady) {
    window.faqsReady = true;
    const setOpen = (toggle, open) => {
      const answer = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!answer) return;
      toggle.setAttribute('aria-expanded', String(open));
      answer.hidden = !open;
    };
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-faq-toggle]');
      if (!toggle) return;
      const opening = toggle.getAttribute('aria-expanded') !== 'true';
      if (opening) {
        const faqs = toggle.closest('[data-faqs]') || document;
        faqs.querySelectorAll('[data-faq-toggle][aria-expanded="true"]').forEach((other) => {
          if (other !== toggle) setOpen(other, false);
        });
      }
      setOpen(toggle, opening);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const answer = event.target.closest && event.target.closest('[data-faq-answer]');
      if (!answer || answer.hidden) return;
      const toggle = document.querySelector('[aria-controls="' + answer.id + '"]');
      if (!toggle) return;
      setOpen(toggle, false);
      toggle.focus();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const footer = document.querySelector('[data-footer]');
    if (!footer) return;
    const desktop = window.matchMedia('(min-width: 1200px)');
    const groups = Array.from(footer.querySelectorAll('[data-footer-column]'))
      .map((column) => ({ column, toggle: column.querySelector('[data-footer-toggle]'), panel: column.querySelector('[data-footer-panel]') }))
      .filter((g) => g.toggle && g.panel);

    const setOpen = (g, open) => {
      g.toggle.setAttribute('aria-expanded', String(open));
      g.panel.hidden = !open;
      g.column.toggleAttribute('data-open', open);
    };
    // Mobile: every group starts closed, one open at a time. Desktop: every panel shows and the toggles are hidden by CSS.
    const layout = () => groups.forEach((g) => {
      if (desktop.matches) { g.panel.hidden = false; g.toggle.setAttribute('aria-expanded', 'false'); g.column.removeAttribute('data-open'); }
      else setOpen(g, false);
    });
    layout();
    desktop.addEventListener('change', layout);

    groups.forEach((g) => {
      g.toggle.addEventListener('click', () => {
        const open = g.toggle.getAttribute('aria-expanded') !== 'true';
        groups.forEach((other) => { if (other !== g) setOpen(other, false); });
        setOpen(g, open);
      });
    });
    // Escape inside an open group closes it and returns focus to its toggle
    footer.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || desktop.matches) return;
      const open = groups.find((g) => g.column.hasAttribute('data-open') && g.column.contains(e.target));
      if (!open) return;
      setOpen(open, false);
      open.toggle.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-header]');
    if (!header) return;
    const desktop = window.matchMedia('(min-width: 1200px)');

    // Mobile menu toggle
    const toggle = header.querySelector('[data-menu-toggle]');
    const toggleLabel = header.querySelector('[data-menu-toggle-label]');
    const setMenu = (open) => {
      header.toggleAttribute('data-menu-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggleLabel.textContent = open ? toggle.dataset.labelClose : toggle.dataset.labelOpen;
    };
    toggle.addEventListener('click', () => setMenu(!header.hasAttribute('data-menu-open')));

    // Dropdowns: one open at a time, hover opens on desktop, Escape and outside clicks close
    const details = Array.from(header.querySelectorAll('[data-nav-details]'));
    const closeAll = (except) => details.forEach((d) => { if (d !== except) d.open = false; });
    const keepPanelOnScreen = (d) => {
      const panel = d.querySelector('.site-nav__panel');
      if (!panel || !desktop.matches) return;
      panel.style.setProperty('--header-panel-shift', '0px');
      const rect = panel.getBoundingClientRect();
      const bar = header.querySelector('.site-header__bar');
      const inner = bar.getBoundingClientRect().right - parseFloat(getComputedStyle(bar).paddingRight || 0);
      const overflow = rect.right - inner;
      if (overflow > 0) panel.style.setProperty('--header-panel-shift', `${-Math.ceil(overflow)}px`);
    };
    let hoverTimer;
    details.forEach((d) => {
      d.addEventListener('toggle', () => { if (d.open) { closeAll(d); keepPanelOnScreen(d); } });
      d.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse' || !desktop.matches) return;
        clearTimeout(hoverTimer);
        d.open = true;
      });
      d.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse' || !desktop.matches) return;
        hoverTimer = setTimeout(() => { d.open = false; }, 120);
      });
    });
    document.addEventListener('click', (e) => { if (!header.contains(e.target)) closeAll(); });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const open = details.find((d) => d.open);
      if (open) { open.open = false; open.querySelector('summary').focus(); return; }
      if (header.hasAttribute('data-menu-open')) { setMenu(false); toggle.focus(); }
    });
    desktop.addEventListener('change', () => { closeAll(); setMenu(false); });

    // Announcement bar: manual previous and next, no auto-rotate
    const items = Array.from(header.querySelectorAll('[data-announcement-item]'));
    if (items.length > 1) {
      let index = items.findIndex((el) => !el.hidden);
      const show = (next) => {
        items[index].hidden = true;
        index = (next + items.length) % items.length;
        items[index].hidden = false;
      };
      header.querySelector('[data-announcement-prev]').addEventListener('click', () => show(index - 1));
      header.querySelector('[data-announcement-next]').addEventListener('click', () => show(index + 1));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-content"] && !Shopify.designMode) return;
  try {
    
  // Page content tables: copy each column's header name into every cell of that column, so below 1200 a row can
  // show as a card with each value under its name (the mobile frames 32:24505 and 32:25330). The names are real
  // text, so a screen reader hears them once the table is shown as cards; on desktop they are not displayed.
  (() => {
    const label = (root) => {
      root.querySelectorAll('[data-page-content-body] table').forEach((table) => {
        if (table.classList.contains('page-content__table--cards')) return;
        const rows = Array.from(table.rows);
        if (rows.length < 2) return;
        const names = Array.from(rows[0].cells).map((cell) => cell.textContent.trim());
        rows.slice(1).forEach((row) => {
          Array.from(row.cells).forEach((cell, index) => {
            if (!names[index]) return;
            const name = document.createElement('span');
            name.className = 'page-content__cell-label';
            name.textContent = names[index];
            cell.prepend(name);
          });
        });
        table.classList.add('page-content__table--cards');
      });
    };
    // The compiled scripts can run before the page body is parsed, so label once the document is ready.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => label(document));
    } else {
      label(document);
    }
    document.addEventListener('shopify:section:load', (event) => label(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["three-block-grid"] && !Shopify.designMode) return;
  try {
    
  // "Line up the text across a row" (Software categories 32:15231): on desktop, each card's text starts at the same
  // height as the other cards in its row, however many lines their label, title and subtitle take; the space goes
  // above the text. Measured again whenever the grid changes size (fonts, images, the window).
  (() => {
    const align = (grid) => {
      const texts = Array.from(grid.querySelectorAll(':scope > .content-card .content-card__text'));
      texts.forEach((text) => text.style.removeProperty('margin-top'));
      if (!window.matchMedia('(min-width: 1200px)').matches) return;
      const rows = new Map();
      texts.forEach((text) => {
        const card = text.closest('.content-card');
        const top = Math.round(card.getBoundingClientRect().top);
        const offset = text.getBoundingClientRect().top - card.getBoundingClientRect().top;
        if (!rows.has(top)) rows.set(top, []);
        rows.get(top).push({ text, offset });
      });
      rows.forEach((items) => {
        const lowest = Math.max(...items.map((item) => item.offset));
        items.forEach(({ text, offset }) => {
          if (lowest - offset < 1) return;
          const base = parseFloat(getComputedStyle(text).marginTop) || 0;
          text.style.marginTop = `${base + lowest - offset}px`;
        });
      });
    };
    const start = (root) => {
      root.querySelectorAll('[data-align-text]').forEach((grid) => {
        if (grid.alignObserver) return;
        grid.alignObserver = new ResizeObserver(() => requestAnimationFrame(() => align(grid)));
        grid.alignObserver.observe(grid);
        align(grid);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => start(document));
    } else {
      start(document);
    }
    document.addEventListener('shopify:section:load', (event) => start(event.target));
  })();

  // Mobile slider for 3 Block Grid: the list scrolls natively (swipe, trackpad, keyboard focus); the arrows scroll by
  // one card and are disabled at either end. A custom element, so it starts again when the theme editor re-renders
  // the section.
  if (!customElements.get('three-block-slider')) {
    customElements.define('three-block-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.prev = this.querySelector('[data-slider-prev]');
        this.next = this.querySelector('[data-slider-next]');
        if (!this.track || !this.prev || !this.next) return;
        this.onScroll = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev.addEventListener('click', () => this.go(-1));
        this.next.addEventListener('click', () => this.go(1));
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        if (this.resize) this.resize.disconnect();
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }

      step() {
        const card = this.track.querySelector(':scope > li');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
      }

      go(direction) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * this.step(), behavior: reduce ? 'auto' : 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const x = this.track.scrollLeft;
        this.toggleAttribute('data-overflowing', max > 1);
        this.prev.disabled = x <= 1;
        this.next.disabled = x >= max - 1;
        // A disabled button drops focus to the page, so a keyboard user who reaches an end keeps it on the other arrow
        const active = document.activeElement;
        if (active === this.next && this.next.disabled) this.prev.focus({ preventScroll: true });
        if (active === this.prev && this.prev.disabled) this.next.focus({ preventScroll: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
